"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitiveDataClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("../../authenticated.client");
const settings_1 = require("../../../settings");
class CompetitiveDataClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    getAllCompetitors(projectId, catalogId, search, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/competitors?${this.getQueryString(Object.assign(Object.assign({}, search), { newService }))}`);
            return response.payload || [];
        });
    }
    getSearchCompetitor(request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, catalogId } = request, payload = tslib_1.__rest(request, ["projectId", "catalogId"]);
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/competitors/stores${newService ? '?newService=true' : ''}`, payload);
            return response.payload;
        });
    }
    getSearchCompetitorReseller(request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, catalogId } = request, payload = tslib_1.__rest(request, ["projectId", "catalogId"]);
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/competitors/resellers${newService ? '?newService=true' : ''}`, payload);
            return response.payload;
        });
    }
    getCompetitiveDataMetrics(projectId, catalogId, params, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/competitive-data/competitor/metrics?${this.getQueryString(Object.assign(Object.assign({}, params), { newService }))}`);
            return response.payload;
        });
    }
    getCompetitiveDataPriceDistribution(projectId, catalogId, params, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/catalogs/${catalogId}/competitive-data/competitor/price-distribution?${this.getQueryString(Object.assign(Object.assign({}, params), { newService }))}`);
            return response.payload;
        });
    }
    getSearchCompetitiveData(projectId, catalogId, request, newService) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/catalogs/${catalogId}/competitive-data/competitor/competitor-product-search${newService ? '?newService=true' : ''}`, request);
            return response.payload;
        });
    }
    downloadXlsx(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/catalogs/${catalogId}/competitive-data/competitor/export`;
            return this.executeRaw('post', url, request);
        });
    }
    downloadProductXlsx(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/catalogs/${catalogId}/competitive-data/competitor/export/product`;
            return this.executeRaw('post', url, request);
        });
    }
}
exports.CompetitiveDataClient = CompetitiveDataClient;
//# sourceMappingURL=competitive-data.client.js.map